"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const base_ui_components_molecules_rate_title_1 = __importDefault(require("@motorata/base-ui.components.molecules.rate-title"));
const base_ui_components_molecules_slider_1 = require("@motorata/base-ui.components.molecules.slider");
const base_ui_utils_finance_1 = require("@motorata/base-ui.utils.finance");
const base_ui_components_atoms_radio_slider_1 = __importDefault(require("@motorata/base-ui.components.atoms.radio-slider"));
const base_ui_data_1 = require("@motorata/base-ui.data");
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const base_ui_services_api_service_1 = require("@motorata/base-ui.services.api-service");
const styled_components_1 = __importDefault(require("styled-components"));
const base_ui_components_atoms_radio_1 = __importDefault(require("@motorata/base-ui.components.atoms.radio"));
const getFirstAllowFinance = (allowFinances) => {
    let finance = "";
    Object.entries(allowFinances).forEach(entry => {
        const [key, value] = entry;
        if (value && finance === "") {
            finance = key;
        }
    });
    return finance;
};
const getAllowedFinances = (allowFinances) => {
    const arr = [];
    base_ui_data_1.FINANCE_ARRAY.forEach(el => {
        // @ts-ignore
        if (allowFinances[el[1]]) {
            arr.push(el);
        }
    });
    return arr;
};
const generateInitialState = (state, allowFinances) => {
    var _a, _b, _c, _d, _e;
    return {
        // @ts-ignore
        type: state.type && allowFinances[state.type] ? state.type : getFirstAllowFinance(allowFinances),
        price: (_a = state.price) !== null && _a !== void 0 ? _a : 80000,
        priceType: (_b = state.priceType) !== null && _b !== void 0 ? _b : "gross",
        period: (_c = state.period) !== null && _c !== void 0 ? _c : 60,
        payment: (_d = state.payment) !== null && _d !== void 0 ? _d : 40,
        repurchase: (_e = state.repurchase) !== null && _e !== void 0 ? _e : 40,
    };
};
const CalculationBlock = ({ initParams, year = new Date().getFullYear(), onChangeParams = () => { }, onChangeCalculation = () => { }, onChangeLoading = () => { }, showValueSlider = true, showRepurchase = true, showPriceType = true, additionalData, allowFinances = {
    leasing: true,
    credit: true,
}, }) => {
    const timeoutId = (0, react_1.useRef)(null);
    const callbacktId = (0, react_1.useRef)(Math.random());
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [calculation, setCalculation] = (0, react_1.useState)(null);
    const [state, setState] = (0, react_1.useState)(generateInitialState(initParams, allowFinances));
    const handleChangeString = ({ name, value }) => {
        setState(Object.assign(Object.assign({}, state), { [name]: value }));
    };
    const handleChange = ({ name, value }) => {
        if (name === "period") {
            setState(Object.assign(Object.assign({}, state), { period: value, repurchase: (0, base_ui_utils_finance_1.getValidRVRange)(value)[1] }));
            return;
        }
        if (state.period && name === "repurchase") {
            setState(Object.assign(Object.assign({}, state), { repurchase: (0, base_ui_utils_finance_1.getValidRepurchase)(state.period, value) }));
            return;
        }
        setState(Object.assign(Object.assign({}, state), { [name]: value }));
    };
    const fetchRate = (0, react_1.useCallback)((newTimeoutId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            onChangeLoading(true);
            const params = {
                type: state.type,
                year,
                price: state.price,
                priceType: state.priceType,
                period: state.period,
                payment: state.payment,
                repurchase: state.repurchase,
            };
            const res = yield base_ui_services_api_service_1.FinanceService.calculate(params);
            onChangeCalculation(res);
            setCalculation(res);
        }
        catch (e) {
            console.log("[ERROR calculate API]:", e);
        }
        finally {
            if (newTimeoutId === callbacktId.current) {
                setLoading(false);
                onChangeLoading(false);
            }
        }
    }), [state.type, state.price, state.priceType, state.period, state.payment, state.repurchase]);
    (0, react_1.useEffect)(() => {
        setLoading(true);
        onChangeLoading(true);
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }
        callbacktId.current = Math.random();
        // @ts-ignore
        timeoutId.current = setTimeout(() => {
            onChangeParams(state);
            fetchRate(callbacktId.current);
        }, 1000);
    }, [
        state.type,
        state.price,
        state.priceType,
        state.price,
        state.period,
        state.payment,
        state.repurchase,
    ]);
    (0, react_1.useEffect)(() => {
        setState(generateInitialState(initParams, allowFinances));
    }, [
        initParams.type,
        initParams.price,
        initParams.priceType,
        initParams.period,
        initParams.payment,
        initParams.repurchase,
    ]);
    return (react_1.default.createElement(base_ui_components_atoms__atoms_1.Box, null,
        react_1.default.createElement(base_ui_components_atoms_radio_slider_1.default, { name: "type", options: getAllowedFinances(allowFinances), value: state.type, onChange: handleChangeString, marginBottom: "M", background: "background", boxShadow: false }),
        react_1.default.createElement(base_ui_components_atoms__atoms_1.Box, { marginBottom: "M" },
            showValueSlider && (react_1.default.createElement(Grid, { marginTop: "S", marginBottom: "S", gtc: showPriceType ? "1fr max-content" : "1fr" },
                react_1.default.createElement(base_ui_components_molecules_slider_1.SliderWithInput, { labelIcon: "payment", label: `Wartość przedmiotu${!showPriceType ? ` (${(0, base_ui_data_1.translate)(state.priceType)})` : ''}`, endAdornment: "z\u0142", inputWidth: "135px", name: "price", value: state.price, onChange: handleChange, min: 10000, max: 500000, marginTop: "0", marginBottom: "0" }),
                showPriceType && (react_1.default.createElement(base_ui_components_atoms_radio_1.default, { name: "priceType", value: state.priceType, options: base_ui_data_1.PRICE_TYPE_ARRAY, onChange: handleChange, height: "max-content", margin: "auto 0" })))),
            react_1.default.createElement(base_ui_components_molecules_slider_1.SliderWithInput, { labelIcon: "calendar", label: "Ilo\u015B\u0107 rat", endAdornment: "mies.", inputWidth: "110px", name: "period", value: state.period, onChange: handleChange, min: 24, max: 72, step: 12, marginBottom: "0", disabledInput: true }),
            react_1.default.createElement(base_ui_components_molecules_slider_1.SliderWithInput, { labelIcon: "payment", label: "Wp\u0142ata w\u0142asna", endAdornment: "%", inputWidth: "110px", name: "payment", value: state.payment, onChange: handleChange, min: 1, max: state.type === "leasing" ? 45 : 99, marginBottom: "0", disabledInput: true }),
            state.type === "leasing" && showRepurchase && (react_1.default.createElement(base_ui_components_molecules_slider_1.SliderWithInput, { labelIcon: "repurchase", label: "Wykup", endAdornment: "%", inputWidth: "110px", name: "repurchase", value: state.repurchase, onChange: handleChange, min: (0, base_ui_utils_finance_1.getValidRVRange)(state.period)[0], max: (0, base_ui_utils_finance_1.getValidRVRange)(state.period)[1], marginBottom: "0", disabledInput: true }))),
        !showValueSlider && (react_1.default.createElement(base_ui_components_atoms__atoms_1.Row, { justifyContent: "space-between" },
            react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { type: "secondary" }, "Cena"),
            react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { type: "secondary" },
                (0, base_ui_utils_finance_1.formatPrice)(state.price),
                " z\u0142 brutto"))),
        additionalData &&
            Object.entries(additionalData).map(entry => {
                var _a;
                const [key, value] = entry;
                return (react_1.default.createElement(base_ui_components_atoms__atoms_1.Row, { key: key, justifyContent: "space-between" },
                    react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { type: "secondary" }, key),
                    react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { type: "secondary" }, (_a = (0, base_ui_data_1.translate)(value)) !== null && _a !== void 0 ? _a : value)));
            }),
        react_1.default.createElement(base_ui_components_molecules_rate_title_1.default, { marginTop: "S", loading: loading, title: "Twoja rata ju\u017C od", rate: calculation === null || calculation === void 0 ? void 0 : calculation.price, rateBottom: calculation === null || calculation === void 0 ? void 0 : calculation.type })));
};
exports.default = CalculationBlock;
const Grid = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  display: grid;
  grid-template-columns: ${({ gtc }) => gtc};
  grid-gap: ${({ theme }) => theme.space.S};

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;
//# sourceMappingURL=CalculationBlock.js.map